/**
 * One-shot `<style>` injection. Components co-locate their token-driven CSS and
 * register it once per id — this is how primitives ship `:focus-visible`,
 * `:hover`, and `prefers-reduced-motion` rules without a bundler CSS pipeline.
 * SSR-safe: a no-op when there is no `document`.
 */
const injected = new Set<string>();

/** Append `css` under `<style id>` exactly once. Guarded for non-DOM runtimes. */
export function ensureStyles(id: string, css: string): void {
  if (typeof document === 'undefined') return;
  if (injected.has(id)) return;
  injected.add(id);
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  document.head.appendChild(style);
}
